export const isJoinWorkspaceLink = (pathname: string) => {
  return (
    pathname === '/workspace/[workspaceId]/[workspaceName]/admin/shared-invite'
  )
}
